// Trending products carousel: arrows and the scroll progress line.
// Mirrors browse-collections so both carousels behave identically.

function initTrending(row) {
  if (row.dataset.trendingInit) return;
  row.dataset.trendingInit = '1';

  const track = row.querySelector('[data-tp-track]');
  if (!track) return;

  const prev = row.querySelector('[data-tp-prev]');
  const next = row.querySelector('[data-tp-next]');
  const thumb = row.querySelector('[data-tp-thumb]');
  let ticking = false;

  function step() {
    const item = track.querySelector('.trending__item');
    if (!item) return track.clientWidth;
    const gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
    return item.getBoundingClientRect().width + gap;
  }

  function update() {
    ticking = false;
    const max = track.scrollWidth - track.clientWidth;

    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = track.scrollLeft >= max - 1;

    if (thumb) {
      const ratio = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
      thumb.style.width = Math.min(ratio * 100, 100) + '%';
      thumb.style.insetInlineStart = (track.scrollLeft / track.scrollWidth) * 100 + '%';
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  prev?.addEventListener('click', function () {
    track.scrollBy({ left: -step(), behavior: 'smooth' });
  });
  next?.addEventListener('click', function () {
    track.scrollBy({ left: step(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
}

// Each row is its own scroller with its own arrows and progress bar, so the
// controls are bound per row rather than per section.
function bootTrending(scope) {
  (scope || document).querySelectorAll('[data-tp-row]').forEach(initTrending);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    bootTrending();
  });
} else {
  bootTrending();
}

document.addEventListener('shopify:section:load', function (e) {
  bootTrending(e.target);
});
